import { LocationId } from "../../services/storage.service";
import { UserService } from "../../services/user.service";

const state = {
  menus: [],
  loc: null,
  menuId: null,
  menuRealId: null,
  menuBranch: null,
  categoryId: null,
};

const getters = {
  allMenus: (state) => {
    return state.menus;
  },
  menuBranch: (state) => {
    return state.menuBranch;
  },
  currentLocation: (state) => {
    return state.loc;
  },
  menuIds: (state) => {
    return state.menuId;
  },
  realMenuId: (state) => {
    return state.menuRealId;
  },
  categoryId: (state) => {
    return state.categoryId;
  },
};

const data = {
  loc_id: parseInt(LocationId.getLocationId()),
};

const actions = {
  // getMenus({ commit }) {
  //   axios
  //     .post("https://deus.khaanpin.com/appapi/menulist/", data)
  //     .then((res) => {
  //       console.log("MENU LIST API CALL", res.data.data);
  //       commit("setMenus", res.data.data);
  //     });
  // },
  setLocation({ commit }, loc_id) {
    // alert(loc_id);
    commit("setLocation", loc_id);
  },

  getMenuId({ commit }, menu_id) {
    // alert(menu_id);
    commit("getMenuId", menu_id);
  },

  getRealMenuId({ commit }, menuReal_id) {
    // alert(menuReal_id)
    commit("getRealMenuId", menuReal_id);
  },

  getCategoryId({ commit }, cat_id) {
    // alert(menuReal_id)
    commit("getCategoryId", cat_id);
  },

  async megamenu({ commit }, loc_id) {
    // console.log(loc_id, "locid in megamemuuuuuu.......");
    commit("megamenuRequest");

    try {
      const res = await UserService.megamenu(loc_id);
      // console.log(res, "megamenuuuuuu from megamenu.js");
      commit("setMenus", res.data);
      commit("setMenuBranch", res.branch);
    } catch (e) {
      console.log(e);
    }
  },
};

const mutations = {
  setMenus(state, menus) {
    // console.log("menussssssssssssssss", menus);
    state.menus = menus;
  },
  setMenuBranch(state, menuBranch) {
    // console.log(menuBranch, "hello this is menubranchhhhhhhh")
    state.menuBranch = menuBranch;
  },
  setLocation(state, loc_id) {
    // alert(loc_id)
    state.loc = loc_id;
  },
  getMenuId(state, menu_id) {
    // alert(menu_id)
    // alert(menu_id.id)
    state.menuId = menu_id.name;
  },
  getRealMenuId(state, menu_id) {
    // alert(menu_id);
    state.menuRealId = menu_id;
  },
  getCategoryId(state, cat_id) {
    // alert(menu_id);
    state.categoryId = cat_id;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
